import React from 'react';
import styled from 'styled-components/macro';
import { isEmpty, uniqBy } from 'lodash';
import { PageTitle } from 'styles/appointment';
import SearchIcon from '@material-ui/icons/Search';

import { useFuse } from 'hooks';
import ScheduleAppointmentModal from 'components/general/SchduleAppointmentModal';
import { border, borderRadius } from 'variables/general';
import { grey30 } from 'variables/colors';
import { fontWeightSemiBold } from 'variables/font';
import Button from 'components/ui/Button';
import { siteNameGenerator } from 'helpers/site-name-generator';

const SearchWrapper = styled.div`
  width: 100%;
  max-width: 24em;
  margin: 0 auto 1.5em;
  padding: 0 1em 1.5em;
  border-bottom: ${border};
`;

const SubLocationButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 20em;
  margin-bottom: 1.5em;
  overflow-y: auto;

  .sub-location-button {
    width: 100%;
    max-width: 22em;
    height: initial;
    padding: 14px 1.5em;

    &:not(:last-of-type) {
      margin-bottom: 1em;
    }
  }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75em;
  border: ${border};
  border-radius: ${borderRadius};
`;

const Search = styled.input`
  flex-grow: 1;
  margin-left: 0.5em;
  font-size: 0.875em;
  border: 0;

  &:focus {
    border: 0;
    outline: 0;
  }

  &::placeholder {
    color: ${grey30};
    font-weight: ${fontWeightSemiBold};
  }
`;

const EmptyHeading = styled.h4`
  margin-bottom: 1.5em;
  text-align: center;
`;

const Component = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const Location = ({
  subLocations,
  organization,
  selectLocation,
  setSelectLocation,
  setStep,
}) => {
  const { logo } = organization;

  const formattedSubLocations = uniqBy(subLocations, 'id').map(
    (subLocation) => ({
      ...subLocation,
      site_name: siteNameGenerator(organization, subLocation),
    }),
  );

  const { hits, onSearch, query } = useFuse(formattedSubLocations, {
    includeScore: true,
    includeMatches: true,
    shouldSort: true,
    keys: ['site_name'],
  });

  const onChange = (e) => {
    onSearch(e);
  };

  const handleButtonClick = (id) => {
    setSelectLocation(id);
  };

  const handleNext = () => {
    setStep('service');
  };

  const LocationButton = ({ id, siteName }) => (
    <Button
      color="primary"
      key={siteName}
      onClick={() => handleButtonClick(id)}
      variant={selectLocation === id ? 'contained' : 'outlined'}
      className="sub-location-button"
    >
      {siteName}
    </Button>
  );

  const LocationOptions = ({ query, hits }) => {
    if (!isEmpty(query) && isEmpty(hits)) {
      return <EmptyHeading>No location results found</EmptyHeading>;
    }

    if (isEmpty(hits)) {
      return (
        <>
          {uniqBy(formattedSubLocations, 'id').map((subLocation) => {
            const { id, site_name: siteName } = subLocation;
            return <LocationButton siteName={siteName} id={id} />;
          })}
        </>
      );
    }

    return (
      <>
        {uniqBy(hits, 'id').map(({ item }) => {
          const { id, site_name: siteName } = item;

          return <LocationButton siteName={siteName} id={id} />;
        })}
      </>
    );
  };

  return (
    <ScheduleAppointmentModal
      logo={logo}
      handleNext={handleNext}
      nextButtonDisabled={!selectLocation}
      fullHeight
    >
      <Component>
        <PageTitle>Select a location</PageTitle>

        {/* <SearchWrapper>
          <SearchBar>
            <SearchIcon />
            <Search
              name="search"
              placeholder="Search locations"
              onChange={onChange}
              autoComplete="off"
            />
          </SearchBar>
        </SearchWrapper> */}

        <SubLocationButtons>
          <LocationOptions query={query} hits={hits} />
        </SubLocationButtons>
      </Component>
    </ScheduleAppointmentModal>
  );
};

export default Location;
